import CompoundingYieldIcon from '~/@mid_ui/icons/CompoundingYieldIcon'
import { FeeImmunityIcon } from '~/@mid_ui/icons/FeeImmunityIcon'
import { FeeImmunityTooltip } from './FeeImmunityTooltip'
import type { YieldRange } from '~/@pages_investing/fee-immunity/feeImmunity.type'

type Props = YieldRange & {
  value?: string
  showTooltip?: boolean
  isCompoundingAnnually?: boolean
}

function FeeImmunityBadge({
  value,
  showTooltip = true,
  isCompoundingAnnually,
  minYieldValue,
  maxYieldValue,
}: Props) {
  const displayValue = isCompoundingAnnually
    ? value?.replace(/\s*%\s*$/, '')
    : value

  return (
    <div className="inline-flex items-center gap-2 rounded bg-purple text-white text-sm select-none px-1.5 py-0.5 whitespace-nowrap">
      <FeeImmunityIcon className="size-4 shrink-0" />
      <div className="flex items-center gap-1">
        <span>{displayValue}</span>
        {isCompoundingAnnually && (
          <CompoundingYieldIcon
            percentColor="#fff"
            arrowColor="#fff"
            className="size-4 shrink-0"
          />
        )}
      </div>
      {showTooltip && (
        <FeeImmunityTooltip
          minYieldValue={minYieldValue}
          maxYieldValue={maxYieldValue}
          isYieldCompoundingAnnually={isCompoundingAnnually}
        />
      )}
    </div>
  )
}

export { FeeImmunityBadge }
